import axios from "axios";

const client = axios;

export default client;
